package mapsearch.historyPathTool

import analyticsdashboard.AnalyticSidePage
import analyticsdashboard.AnalyticsSidePageStore
import analyticsdashboard.PathActiveHighlightedObjectStore
import apiclient.geoobjects.GeoObjectDetails
import apiclient.geoobjects.LatLon
import apiclient.geoobjects.ObjectTags
import apiclient.tags.getUniqueTag
import dev.fritz2.core.RootStore
import dev.fritz2.routing.MapRouter
import koin.koinCtx
import kotlin.js.json
import kotlinx.browser.document
import kotlinx.coroutines.Job
import mainmenu.RouterStore
import map.MapLayersStore
import maplibreGL.FormationMap
import mapsearch.MapRenderOverrides

class ActiveHistoryEntryStore : RootStore<GeoObjectDetails?>(
    initialData = null,
    job = Job(),
) {

    val router: MapRouter by koinCtx.inject()
    val routerStore: RouterStore by koinCtx.inject()
    val formationMap: FormationMap by koinCtx.inject()
    val mapLayersStore: MapLayersStore by koinCtx.inject()
    private val showObjectHistoryPathStore: ShowObjectHistoryPathStore by koinCtx.inject()
    private val pathActiveHighlightedObjectStore: PathActiveHighlightedObjectStore by koinCtx.inject()
    private val analyticsSidePageStore: AnalyticsSidePageStore by koinCtx.inject()
    private val mapRenderOverrides: MapRenderOverrides by koinCtx.inject()

    fun selectHistoryEntry(selected: GeoObjectDetails) {
        // also switch analytics side page
        analyticsSidePageStore.update(AnalyticSidePage.PathsHistory)
//        current?.let { formationMap.removeActiveObjectOverride(it.id) }
        console.log("History Event:", selected)
//        formationMap.addActiveObjectOverride(selected)
        formationMap.panTo(center = LatLon(selected.latLon.lat, selected.latLon.lon))
        update(selected)
        val connectedObjectId = selected.tags.getUniqueTag(ObjectTags.ConnectedTo)
        connectedObjectId?.let { objId ->
            console.log("Connected ID is: $objId")
            pathActiveHighlightedObjectStore.current?.let { formationMap.removeActiveObjectOverride(it) }
            formationMap.addActiveObjectOverride(objId = objId)
            pathActiveHighlightedObjectStore.update(objId)
        }
        val scrollOptions = json(
            "behavior" to "smooth",
            "block" to "center",
//                "inline" to "nearest"
        )
        document.getElementById("${selected.id}-history-button")?.scrollIntoView(scrollOptions)
        showObjectHistoryPathStore.update(true)
    }

    init {
        data handledBy { activeHistoryEntry ->
            mapRenderOverrides.pushActiveHistoryEntry(activeHistoryEntry)
        }
    }
}
